import { Endpoint } from '../endpoint';
import { 
  ProjectTemplateFolderId, 
  ProjectTemplateFolderResponse, 
  ProjectTemplateFolderStructureResponse,
  SearchResult 
} from '@business/entities/project/ProjectTemplateFolderResponse';

/**
 * Fetch folders with optional parent filtering
 */
export function fetchFolders(parentId?: ProjectTemplateFolderId, objectType: string = 'project_template') {
  return Endpoint.get<ProjectTemplateFolderResponse[]>(`@gc/project-template-folder`, { 
    params: { 
      parentId: parentId || '0',
      objectType 
    } 
  });
}

/**
 * Fetch a specific folder by ID
 */
export function fetchFolder(id: ProjectTemplateFolderId) {
  return Endpoint.get<ProjectTemplateFolderResponse>(`@gc/project-template-folder/folder/${id}`);
}

/**
 * Create a new folder
 */
export function createFolder(data: Partial<ProjectTemplateFolderResponse> & { objectType?: string }) {
  return Endpoint.post<ProjectTemplateFolderResponse>(`@gc/project-template-folder`, { 
    data: {
      ...data,
      objectType: data.objectType || 'project_template'
    }
  });
}

/**
 * Update an existing folder
 */
export function updateFolder(id: ProjectTemplateFolderId, data: Partial<ProjectTemplateFolderResponse>) {
  return Endpoint.patch<ProjectTemplateFolderResponse>(`@gc/project-template-folder/${id}`, { data });
}

/**
 * Delete a folder
 */
export function deleteFolder(id: ProjectTemplateFolderId, moveToParent: boolean = false) {
  return Endpoint.delete<{ success: boolean }>(`@gc/project-template-folder/${id}`, { 
    params: { moveToParent: moveToParent ? '1' : '0' }
  });
}

/**
 * Get folder structure for organizing
 */
export function folderStructure(folderId?: ProjectTemplateFolderId, objectType: string = 'project_template') {
  return Endpoint.get<ProjectTemplateFolderStructureResponse>(`@gc/project-template-folder/folder-structure`, { 
    params: { 
      folderId: folderId || '',
      objectType 
    } 
  });
}

/**
 * Get breadcrumbs for a folder
 */
export function getBreadcrumbs(id: ProjectTemplateFolderId) {
  return Endpoint.get<{ breadcrumbs: { id: string; name: string; object_type: string }[] }>(`@gc/project-template-folder/${id}/breadcrumbs`);
}

/**
 * Move a template to a different folder
 */
export function moveTemplate(data: { templateId: string; templateType: string; toFolderId: string }) {
  return Endpoint.post<{ success: boolean; message: string }>(`@gc/project-template-folder/move-template`, { data });
}

/**
 * Search templates and folders
 */
export function searchTemplates(query: string, objectType: string = 'project_template') {
  return Endpoint.get<SearchResult[]>(`@gc/project-template-folder/search`, { 
    params: { 
      query,
      objectType 
    } 
  });
}
